import $ from 'jquery';


function animateLogo(){
    $(window).on('scroll', () => {
        if ($(window).width() >= 992) {
            if ($(window).scrollTop() > 100) {
                $('.logo-main img').addClass('collapsed');
            } else {
                $('.logo-main img').removeClass('collapsed');
            }
        }
    });
}


export default () => {
    animateLogo();
};


// WEBPACK FOOTER //
// ../views/components/logo/logo.js